import {
    TablePage,
    EditPage,
    ViewPage,
} from 'src/views/cec-admin/quotation'
import pathMap from "src/paths/PathMap_CeCAdmin";

export default class QuotationRoute {
    getConfigurations() {
        return [
            {
                exact: true,
                path: pathMap.CEC_ADMIN_QUOTATION_LIST_VIEW,
                component: TablePage
            },
            {
                exact: true,
                path: pathMap.CEC_ADMIN_QUOTATION_EDIT_VIEW,
                component: EditPage
            },
            {
                exact: true,
                path: pathMap.CEC_ADMIN_QUOTATION_DETAILS_VIEW,
                component: ViewPage
            }
        ]
    }
}